import { PlaceholderDescriptor } from "../../utils/invitationMessageGenerator"

interface TemplateSectionProps {
  template: string
  onChange: (value: string) => void
  availablePlaceholders: PlaceholderDescriptor[]
}

export default function TemplateSection({
  template,
  onChange,
  availablePlaceholders,
}: TemplateSectionProps) {
  return (
    <>
      <div className="template-section">
        <label className="form-label">Template messaggio</label>
        <textarea
          className="form-input template-textarea"
          rows={5}
          value={template}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>

      <div className="placeholder-panel">
        <div className="panel-label">Placeholder disponibili</div>
        <div className="placeholder-list">
          {availablePlaceholders.map((placeholder) => (
            <div key={placeholder.token} className="placeholder-item">
              <div>
                <span className="placeholder-token">{placeholder.token}</span>
                <span className="placeholder-description">{placeholder.description}</span>
              </div>
              <div className="placeholder-example">
                <span className="placeholder-example-label">Esempio:</span>{" "}
                <span className="placeholder-example-value">{placeholder.example}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
